import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import { persistor } from "../../app/store/store";
import { t } from "i18next";
import { useEffect } from "react";

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();
  let text = "";

  if (isRouteErrorResponse(error)) {
    text = t("ReqErr");
  } else {
    text = t("NotAuthorized");
  }

  useEffect(() => {
    if (text === t("NotAuthorized")) {
      setTimeout(() => {
        persistor.purge();
        navigate("/login");
        window.location.reload();
      }, 1500);
    } else {
      setTimeout(() => {
        navigate(-1);
      }, 1500);
    }
  }, [text, navigate]);

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>{text}</p>
    </div>
  );
}
